import BlurImage from "../components/BlurImage";
import Gallery from "../components/Gallery";
import { GoalItem } from "../components/GoalItem";
import { FaReact, FaCss3Alt } from "react-icons/fa";
import { SiPokemon } from "react-icons/si";
import { SiFirebase } from "react-icons/si";

function About() {
  const goals = [
    {
      title: "Get fun!",
      description: "Trying out my knowledge in React and JavaScript",
    },
    {
      title: "Create a beautiful and user-friendly UI",
      description:
        "Applying good UX practices to create a UI tailored for fans, while avoiding sluggish user experience.",
    },
    {
      title: "Deploying the app ",
      description:
        "Having a local version of the project first, and preparing it for deployment while solving some issues that dind't show up locally",
    },
  ];
  return (
    <div id={"root-about"}>
      <div className="about-main-container">
        <div style={{ textAlign: "center" }}>
          <h1> "Hello, hello."</h1>
        </div>

        <div className="inspire" id="about-me">
          <div className="container-img-nephew">
            <img
              title="sobrino"
              className="img-nephew"
              alt="nephew"
              src="https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2Fcharmander-pokemon.jpg?alt=media&token=64b1df99-b33c-4af4-89a5-4c556753b46a"
            />
          </div>
          <div className="txt-presentation">
            <p>
              I'm Ros... Rosario, a software Engineer passionate about creating
              friendly interfaces that improve user experience on the web. Since
              i started programming, i've always enjoyed exploring new
              technologies and finding{" "}
              <span className="highlighted-txt">
                creative ways to build dynamic websites.
              </span>{" "}
              This proyect stems from my love for Pokémon, and my enthusiasm for
              improving my Front-End development skills using{" "}
              <span className="highlighted-txt">React</span> and REST APIs. I
              was also inspired by my nephews, who are obsessed with Pokémon
              cards.🃏✨( Charmander drawing made by my nephew Sebastian.)
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className="big-takeaway-container">
          <div className="subtitles-about">
            <h2>CREATING POKEDEX: The big takeaway</h2>
          </div>
          <div className="takeaway-paraphs">
            <div className="takeaways-p">
              <li>
                One of the biggest challlanges was managing asynchronous data
                from the API efficiently. It taught me the value of custom hooks
                and{" "}
                <span className="highlighted-txt">
                  clean component structure
                </span>
                . This project helped me grow both technically and creatively.
              </li>
              <li>
                Another challange was deepending my understanding of React and
                learning how to structure a{" "}
                <span className="highlighted-txt">
                  scalable and responsive UI{" "}
                </span>
                using real-world data.
              </li>
              <li>
                It helped me understand how to turn a creative idea into a fully
                functiona web app, by combining design, logic and data
              </li>
            </div>
            <div className="container-process-img">
              <BlurImage
                lowRes="https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/notary-nine%2Flow-res-blur.jpg?alt=media&token=c84fb025-091e-4a38-8959-18a1741190e1"
                highRes="https://firebasestorage.googleapis.com/v0/b/bornsrss-8ab5d.appspot.com/o/pokemon%2FElemento_page-0001.jpg?alt=media&token=3e3d76d3-4bf3-455a-9f6d-6211e301fed0"
                alt="nephew"
                title="sobrino"
                width="100%"
                height="100%"
              />
            </div>
          </div>
        </div>
        <div className="proy-objectives-main">
          <div className="subtitles-about">
            <h2>PROYECT OBJECTIVES</h2>
          </div>
          <div className="goals-container">
            {goals.map((goal, index) => (
              <GoalItem
                index={index}
                titleGoal={goal.title}
                desGoal={goal.description}
              />
            ))}
          </div>
        </div>
      </div>
      <div>
        <div className="subtitles-about">
          <h2>TECH STACK</h2>
        </div>

        <div className="tech-stack">
          <a
            href="https://react.dev/"
            target="_blank"
            rel="noopener noreferrer"
            title="React"
          >
            <FaReact className="icon-tech react" />
          </a>

          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://firebase.google.com/?hl=es-419"
            className="icon-tech react"
            title="firebase"
          >
            <SiFirebase />
          </a>
          <a
            href="https://developer.mozilla.org/en-US/docs/Web/JavaScript"
            target="_blank"
            rel="noopener noreferrer"
            title="CSS"
          >
            <FaCss3Alt className="icon-tech cssalt" />
          </a>
          <a
            href="https://pokeapi.co/"
            target="_blank"
            rel="noopener noreferrer"
            title="PokeAPI"
          >
            <SiPokemon className="icon-tech pokemon" />
          </a>
        </div>
      </div>

      <div className="main-About">
        <div>
          <div className="subtitles-about">
            <h2>DESIGN PROCESS</h2>
          </div>
          <p className="txt-presentation">
            I started with wireframes and low-fidelity sketches to define the{" "}
            <span className="highlighted-txt">structure and user flow</span>.
            Step by Step, I moved into high-fidelity designs and responsive
            layouts, always keeping user experience in mind. Explore the gallery
            below to see some of the{" "}
            <span className="highlighted-txt"> design process</span> — from
            early concepts to the final interface.
          </p>
        </div>
        <Gallery />
      </div>
      <footer className="footer-pke">
        <div className="footer-bottom-pke">
          <p>&copy; 2025 pandasneezing. Todos los derechos reservados.</p>
        </div>
      </footer>
    </div>
  );
}

export default About;
